import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormProps, getRequiredValidationRule, getValidationErrorProps } from 'util/Form';

interface CurrencyQuestionFormItemProps extends FormProps {
  fieldName: string;
  required?: boolean;
}

const CurrencyQuestionFormItem: React.FunctionComponent<CurrencyQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          required={required}
          {...getValidationErrorProps(error)}
          disabled={disabled}
          type={'number'}
          InputProps={{
            inputProps: { min: 0 },
            startAdornment: <InputAdornment position={'start'}>$</InputAdornment>,
          }}
          placeholder={'0'}
        />
      )}
      name={fieldName}
      control={control}
      rules={{
        required: getRequiredValidationRule('your answer', false, required),
      }}
    />
  );
};
export default CurrencyQuestionFormItem;
